import {
  useGetPrePurchaseForm,
  useGetPrePurchaseResponse
} from 'api/queries/events/pre-purchase-questions';

function useGetFormData(eventId: string, prePurchaseFormId: string) {
  let isResponseError = false;

  const {
    data: form,
    isLoading: isLoadingPrePurchaseForm,
    isError: isErrorPrePurchaseForm
  } = useGetPrePurchaseForm({ eventId }, { enabled: !!prePurchaseFormId });

  const {
    data: response,
    isLoading: isLoadingPrePurchaseResponse,
    isError: isErrorPrePurchaseResponse,
    error: errorPrePurchaseResponse
  } = useGetPrePurchaseResponse({ eventId }, { enabled: !!prePurchaseFormId });

  const isLoading = isLoadingPrePurchaseForm || isLoadingPrePurchaseResponse;

  // If the response is not found, we don't want to show an error. It means the user hasn't answered the questions yet.
  if (
    isErrorPrePurchaseResponse &&
    errorPrePurchaseResponse?.type !== 'NotFoundError'
  ) {
    isResponseError = true;
  }

  return {
    form,
    response,
    isLoading,
    isError: isErrorPrePurchaseForm || isResponseError
  };
}

export default useGetFormData;
